module.exports = __webpack_public_path__ + "static/media/profile-picture.3a8ceeb1.jpg";